import { INSTANCELIST, INSTANCE } from './API.js';

export const getOrders = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { sort, range, filter, tabFilter } = queryKey[1];

    INSTANCELIST({
      method: 'get',
      url: '/orders/details',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(sort),
        range: JSON.stringify(range),
        filter: JSON.stringify(filter),
        ...tabFilter,
      },
    })
      .then(resolve)
      .catch(reject);
  });

export const getOrdersMine = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { sort, filter } = queryKey[1];

    INSTANCE({
      method: 'get',
      url: '/orders/details',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(sort),
        filter: JSON.stringify(filter),
      },
    })
      .then(resolve)
      .catch(reject);
  });

export const getOrderDetails = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { id } = queryKey[1];

    INSTANCE({
      method: 'get',
      url: `/orders/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject);
  });

export const createOrder = (form) =>
  new Promise((resolve, reject) => {
    INSTANCELIST({
      method: 'post',
      url: '/orders',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject);
  });

export const updateOrder = (form, id) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'put',
      url: `/orders/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject);
  });

export const getOrderExcel = (id) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'get',
      url: `/orders/${id}/export`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject);
  });

export const getAdjustmentExcel = (id) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'get',
      url: `/orders/${id}/exportAdjustment`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject);
  });
